import {Component} from '@angular/core'
import {
  ActionSheetButton,
  ActionSheetController,
  AlertController,
  IonicPage,
  ModalController,
  NavController,
  NavParams,
  ViewController
} from 'ionic-angular'
import {Deal, DealStatus, DealStatusDescriptions, Meeting, Operator, ShopOrderStatus} from '../../models/models'
import {ApiProvider} from '../../providers/api/api'
import {OperatorProvider} from '../../providers/operator/operator'
import {SettingsProvider} from '../../providers/settings/settings'
import {AddMeetingPage} from '../add-meeting/add-meeting'
import {ContactListPage} from '../contact-list/contact-list'
import {MeetingPage} from '../meeting/meeting'
import {tap} from "rxjs/operators";
import {ContactProvider} from "../../providers/api/contacts.provider";

@IonicPage()
@Component({
  selector: 'page-meeting-list',
  templateUrl: 'meeting-list.html',
})
export class MeetingListPage {

  to_finalize_count = 0
  planned_next = true
  to_finalize_next = true
  done_next = true

  planned_page = 0
  done_page = 0

  MEETING_PLANNED = 1
  MEETING_DONE = 2
  MEETING_CANCEL = 3
  MEETING_LEAVED = 4

  STATUS = {
    MEETING_PLANNED: "Pianificato",
    MEETING_DONE: "Fatto",
    MEETING_CANCEL: "Annullato",
    MEETING_LEAVED: "Non Presentato"
  }

  DEAL_OPEN = 1
  DEAL_WON = 2
  DEAL_LOST = 3

  tab = 'PLANNED'

  meetings_planned: Meeting[] = []
  meetings_done: Meeting[] = []

  operator: Operator
  isLoading: boolean;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public viewCtrl: ViewController,
              private api: ApiProvider,
              private alertCtrl: AlertController,
              private contactProvider: ContactProvider,
              private modalCtrl: ModalController,
              private operatorProvider: OperatorProvider,
              public settings: SettingsProvider,
              private readonly actionSheetController: ActionSheetController) {
    this.operatorProvider.currentOperator.subscribe(operator => {
      this.operator = operator
      this.refresh()
    })

  }

  productOf(meeting: Meeting): String {
    return meeting?.deal?.product?.name || ""
  }

  meetingStatus(meeting: Meeting) {
    switch (meeting.status) {
      case this.MEETING_PLANNED:
        return "Pianificato"
      case this.MEETING_DONE:
        return "Fatto"
      default:
        return "Annullato"
    }
  }

  isToFinalize(meeting: Meeting): boolean {
    return meeting.deal.conversion &&
      !meeting.deal.conversion.is_finalized &&
      meeting.deal.shop_orders.length &&
      meeting.deal.shop_orders[meeting.deal.shop_orders.length - 1].status === ShopOrderStatus.COMPLETED
  }

  nextPlanned(event) {
    this.isLoading = true
    if (!this.planned_next) {
      event.complete()
      return
    }
    this.planned_page++
    this.api.getPaginatedMeetings(this.operator.id, [this.MEETING_PLANNED], null, null, false, this.planned_page).subscribe(
      page => {
        this.meetings_planned.push(...page.results)
        this.planned_next = page.next !== null
        this.apply_agenda_date(this.meetings_planned)
        this.isLoading = false
      },
      _e => {
      },
      () => {
        if (event != null) event.complete()
      }
    )
  }

  nextDone(event) {
    this.isLoading = true
    if (!this.done_next) {
      event.complete()
      return
    }
    this.done_page++
    this.api.getPaginatedMeetings(this.operator.id, [this.MEETING_CANCEL, this.MEETING_LEAVED, this.MEETING_DONE], null, null, true, this.done_page, 30).subscribe(
      page => {
        this.meetings_done.push(...page.results)
        this.done_next = page.next != null
        this.apply_agenda_date(this.meetings_done)

        this.isLoading = false
      },
      _e => {
      },
      () => {
        if (event != null) event.complete()
      }
    )
  }

  apply_agenda_date(meetings: Meeting[]) {
    meetings.reduce((prev, current) => {
      let c_date: string = current.schedule_datetime.split("T")[0]
      current.show_date = prev == "" || prev != c_date
      return c_date
    }, "")
    return meetings
  }

  open(meeting: Meeting) {
    this.navCtrl.push(MeetingPage, {
      meeting: meeting,
      parent: this,
      operator: this.operator
    })
  }

  reset() {
    this.to_finalize_count = 0
    this.planned_next = true
    this.to_finalize_next = true
    this.done_next = true
    this.meetings_planned = []
    this.meetings_done = []
    this.planned_page = 0
    this.done_page = 0
  }

  refresh() {

    this.isLoading = true
    this.reset()

    this.nextPlanned(null)
    this.nextDone(null)
  }


  selectDeal(deals: Deal[], selectionHandler: (deal: Deal, create: boolean, product_id: number) => void) {

    let myp_deal = deals.find(deal => deal.product.ac_label == this.settings.PRODUCT_MYP)
    let social_deal = deals.find(deal => deal.product.ac_label == this.settings.PRODUCT_SOCIAL)

    let choices = deals.map(
      deal => {
        return {
          text: `${deal.product.name} (${DealStatusDescriptions[deal.status]})`,
          handler: () => {
            selectionHandler(deal, false, null)
          }
        }
      })
    if (!myp_deal) {
      choices.push({
        text: `${this.settings.PRODUCT_MYP}`,
        handler: () => {
          selectionHandler(null, true, this.settings.PRODUCT_MYP_ID)
        }
      })
    }
    if (!social_deal) {
      choices.push({
        text: `${this.settings.PRODUCT_SOCIAL}`,
        handler: () => {
          selectionHandler(null, true, this.settings.PRODUCT_SOCIAL_ID)
        }
      })
    }

    let buttons: ActionSheetButton[] = choices

    buttons.push({
      text: 'Annulla',
      icon: 'close',
      role: 'cancel',
      handler: () => {
        console.log('Cancel clicked');
      }
    })


    const actionSheet = this.actionSheetController.create({
      title: 'Seleziona Deal',
      buttons: buttons
    });
    actionSheet.present();
  }


  addMeeting() {
    let contactModal = this.modalCtrl.create(ContactListPage, {modal: true});
    contactModal.onDidDismiss(contact => {
      if (contact != null) {
        let deals = contact.deals.filter(deal => deal.status == DealStatus.OPEN && this.settings.PRODUCTS.some(p => p == (deal.product && deal.product.ac_label)))

        console.log(deals)
        this.selectDeal(deals, (deal, create, product_id) => {
          if (create) {
            let product_label = product_id == this.settings.PRODUCT_SOCIAL_ID ? this.settings.PRODUCT_SOCIAL : this.settings.PRODUCT_MYP

            return this.api.postDeal(
              contact.id,
              product_id,
              this.settings.PIPELINE_VENDITA_BY_PRODUCT[product_label],
              this.settings.STAGE_APPOINTMENT_TODO_BY_PRODUCT[product_label],
              this.operator.id
            ).pipe(tap(
              _ => {
                this.contactProvider.pushOnAC(contact.id).subscribe(_ => {
                })
              }
            )).subscribe(deal => {
              let meetingModal = this.modalCtrl.create(AddMeetingPage, {
                contact: contact,
                deal: deal
              }, {showBackdrop: true})
              meetingModal.onDidDismiss(_value => {
              })
              meetingModal.present()
            }, e => {
              this.alertCtrl.create({
                title: "Anomalia",
                message: "Si è verificato un errore",
                buttons: [
                  {
                    text: 'Ok',
                    handler: () => {
                    }
                  },
                ]
              }).present()
              console.log(e)
            })

          } else {
            let meetingModal = this.modalCtrl.create(AddMeetingPage, {
              contact: contact,
              deal: deal
            }, {showBackdrop: true})
            meetingModal.onDidDismiss(_value => {
            })
            meetingModal.present()
          }

        })
        // } else if (deals.length === 1) {
        //   let deal = deals[0]
        //   let meetingModal = this.modalCtrl.create(AddMeetingPage, {contact: contact, deal: deal}, {showBackdrop: true})
        //   meetingModal.onDidDismiss(_value => {
        //   })
        //   meetingModal.present()


        console.log("Contatto per appuntamento", contact)
      }
      // this.navCtrl.push(AddMeetingPage, { contact: contact })
    });
    contactModal.present();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MeetingListPage');
  }

  ionViewDidEnter() {
    if (this.operator) {
      this.refresh()
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/meeting-list/meeting-list.ts